/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment form validation helpers.
 *
 * @file assignmentFormValidation.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import Utils from '../../common/utils';
import ValidationUtils from '../../common/validationUtils';
import { VALIDATEDATE_CONSTANTS } from '../../common/constants';
import { ASSIGNMENT_FORM_MODE } from './assignmentFormActions';

export function createDueDateValidator(getValues) {
  return (value) => {
    const dueTime = getValues('dueTime');
    const error = ValidationUtils.validateDate(value, dueTime);

    return error?.message || true;
  };
}

export function createDueTimeValidator() {
  return (value) => {
    const error = ValidationUtils.validateDueTime(value);

    return error?.message || true;
  };
}

export function createModalDueDateValidator() {
  return (value) => ValidationUtils.validateDate(value)?.message || true;
}

export function createAssignmentNameValidator({
  hasContent,
  isTitleGenerating,
  mode,
  showAssignmentNameField = true,
  existingAssignmentTitles,
  titleValidationConfig
}) {
  return (value) => {
    if (!showAssignmentNameField) {
      return true;
    }

    if (
      mode !== ASSIGNMENT_FORM_MODE.EDIT
      && (!hasContent || isTitleGenerating)
    ) {
      return true;
    }

    const titleError = ValidationUtils.validateAssignmentTitle(
      value,
      existingAssignmentTitles,
      titleValidationConfig
    );

    return titleError ? titleError.message : true;
  };
}

export function createChaptersValidator({ tocData, chapterMcqMapping, getValues }) {
  return (chapters) => {
    if (!chapters?.length) {
      return VALIDATEDATE_CONSTANTS.NO_PROPERLY_CHAPTERS;
    }

    const formValues = getValues();
    const tempAssignment = {
      date: formValues.dueDate,
      time: formValues.dueTime,
      chapters,
      textbookCoverage: Utils.createTextbookCoverage(chapters, tocData)
    };

    const chapterError = ValidationUtils.validateMappedChapters(tempAssignment, tocData);

    if (chapterError) {
      return chapterError.message;
    }

    const questionsError = ValidationUtils.getNoQuestionsError(
      chapters,
      tocData,
      chapterMcqMapping
    );

    if (questionsError) {
      return questionsError.message;
    }

    return true;
  };
}
